import apiConfig from "../ApiConfig";

export const getConnectorsApi = async (
  page = 1,
  pageSize = 20,
  search = "",
  category_id = "",
  customer_id = "",
) => {
  try {
    const params = new URLSearchParams({
      page: page.toString(),
      page_size: pageSize.toString(),
      category_id: category_id.toString(),
      customer_id: customer_id.toString(),
    });
    if (search) params.append("search", search);
    const response = await apiConfig.get(
      `api/asset-connectors/connectors/all/?${params}`,
    );
    if (response.data) {
      return response.data;
    } else {
      throw new Error(response.data.message);
    }
  } catch (error) {
    throw error;
  }
};

export const getConnectorsByCategoryApi = async (categoryId) => {
  try {
    const response = await apiConfig.get(
      `api/asset-connectors/connectors/by_category/?category=${categoryId}`,
    );
    if (response.data) {
      return response.data;
    } else {
      throw new Error(response.data.message);
    }
  } catch (error) {
    throw error;
  }
};

export const createConnectorsApi = async (payload) => {
  try {
    const response = await apiConfig.post(
      `api/asset-connectors/connectors/create_connector/`,
      payload,
    );
    if (response.data) {
      return response.data;
    } else {
      throw new Error(response.data.message);
    }
  } catch (error) {
    throw error;
  }
};

export const editConnectorApi = async (connectorId, payload) => {
  try {
    const response = await apiConfig.put(
      `api/asset-connectors/connectors/${connectorId}/edit_connector/`,
      payload,
    );
    if (response.data) {
      return response.data;
    } else {
      throw new Error(response.data.message);
    }
  } catch (error) {
    throw error;
  }
};

export const connectConnectorApi = async (payload) => {
  try {
    const response = await apiConfig.post(
      `api/asset-connectors/connectors/connect_customer_connector/`,
      payload,
    );
    if (response.data) {
      return response.data;
    } else {
      throw new Error(response.data.message);
    }
  } catch (error) {
    throw error;
  }
};

export const disConnectConnectorApi = async (customerId, connectorId) => {
  try {
    const response = await apiConfig.post(
      `api/asset-connectors/connectors/reset_connector_status/?customer_id=${customerId}&connector_id=${connectorId}`,
    );
    if (response.data) {
      return response.data;
    } else {
      throw new Error(response.data.message);
    }
  } catch (error) {
    throw error;
  }
};

export const getInventoryConnectorsApi = async (params) => {
  try {
    const response = await apiConfig.get(
      `api/asset-connectors/connectors/get_assets_connectors/?${params}`,
    );
    if (response.data) {
      return response.data;
    } else {
      throw new Error(response.data.message);
    }
  } catch (error) {
    throw error;
  }
};

export const getInventoryConnectorsByIdApi = async (assetId) => {
  try {
    const response = await apiConfig.get(
      `api/asset-connectors/connectors/${assetId}/get_asset_connector_by_id/`,
    );
    if (response.data) {
      return response.data;
    } else {
      throw new Error(response.data.message);
    }
  } catch (error) {
    throw error;
  }
};

export const getEndUsersByCompanyApi = async (customerMasterId) => {
  try {
    const response = await apiConfig.get(
      `api/asset-connectors/connectors/get_employees_by_customer/?customer_master_id=${customerMasterId}`,
    );
    if (response.data) {
      return response.data;
    } else {
      throw new Error(response.data.message);
    }
  } catch (error) {
    throw error;
  }
};

export const getConnectedConnectorsApi = async (customerID) => {
  try {
    const response = await apiConfig.get(
      `api/asset-connectors/connectors/get_customer_connectors/?customer_id=${customerID}`,
    );
    if (response.data) {
      return response.data;
    } else {
      throw new Error(response.data.message);
    }
  } catch (error) {
    throw error;
  }
};

export const deleteConnectorApi = async (connectorId) => {
  try {
    const response = await apiConfig.delete(
      `api/asset-connectors/connectors/${connectorId}/delete_connector/`,
    );
    if (response.data) {
      return response.data;
    } else {
      throw new Error(response.data.message);
    }
  } catch (error) {
    throw error;
  }
};

export const getConnectorStatsApi = async () => {
  try {
    const response = await apiConfig.get(
      `api/asset-connectors/connectors/connector_stats/`,
    );
    if (response.data) {
      return response.data;
    } else {
      throw new Error(response.data.message);
    }
  } catch (error) {
    throw error;
  }
};

export const getAssetStatsApi = async (customerID) => {
  try {
    const response = await apiConfig.get(
      `api/asset-connectors/connectors/asset_stats/?customer_id=${customerID}`,
    );
    if (response.data) {
      return response.data;
    } else {
      throw new Error(response.data.message);
    }
  } catch (error) {
    throw error;
  }
};

export const getAssetDashboardAgentApi = async (customerID) => {
  try {
    const response = await apiConfig.get(
      `api/asset-connectors/connectors/agent_dashboard/?customer_id=${customerID}`,
    );
    if (response.data) {
      return response.data;
    } else {
      throw new Error(response.data.message);
    }
  } catch (error) {
    throw error;
  }
};

export const getConnectorsCategoryApi = async () => {
  try {
    const response = await apiConfig.get(`api/asset-connectors/get-categories`);
    if (response.data) {
      return response.data;
    } else {
      throw new Error(response.data.message);
    }
  } catch (error) {
    throw error;
  }
};

export const toggleConnectorsStatusApi = async (id) => {
  try {
    const response = await apiConfig.post(
      `api/asset-connectors/connectors/${id}/toggle_active/`,
    );
    if (response.data) {
      return response.data;
    } else {
      throw new Error(response.data.message);
    }
  } catch (error) {
    throw error;
  }
};

export const classifyAssetApi = async (assetId) => {
  try {
    const response = await apiConfig.post(
      `api/asset_classifications/classify/${assetId}/`,
    );
    if (response.data) {
      return response.data;
    } else {
      throw new Error(response.data.message);
    }
  } catch (error) {
    throw error;
  }
};

export const getAssetOwnershipApi = async (assetId) => {
  try {
    const response = await apiConfig.get(
      `api/asset_classifications/ownership/${assetId}/`,
    );
    if (response.data) {
      return response.data;
    } else {
      throw new Error(response.data.message);
    }
  } catch (error) {
    throw error;
  }
};

export const getAssetsByOwner = async (ownerId) => {
  try {
    const response = await apiConfig.get(
      `api/asset-connectors/connectors/get_assets_by_owner/?owner_id=${ownerId}`,
    );
    if (response.data) {
      return response.data;
    } else {
      throw new Error(response.data.message);
    }
  } catch (error) {
    throw error;
  }
};
